import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=b2f91e30&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=ts&"
export * from "./Tab.vue?vue&type=script&lang=ts&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=b2f91e30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f91e30",
  null
  
)

export default component.exports